const TOURNAMENT_MEMBER_STATUS = {
  waited: 1,
  transfered: 2,
  ended: 3,
  levelTransfered: 4,
};

const TOURNAMENT_MEMBER_ACTIONS = {
  transfer: 1,
  finish: 2,
  remove: 3,
  resume: 4,
  levelTransfer: 5,
};

const TOURNAMENT_MEMBER_PRIZE_PLACE = {
  member: 1,
  awarded: 2,
  winner: 3,
};

export default {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
  TOURNAMENT_MEMBER_PRIZE_PLACE,
};
